import { defaultState } from "./state";
import payroll from "./action-types";
import commonTypes from "../common/action-types";
const types = { ...commonTypes, ...payroll };

const registeredUnemployedPeople = (
  registeredUnemployedPeopleState = defaultState.registeredUnemployedPeople,
  action,
) => {
  switch (action.type) {
    case types.SET_REGISTERED_UNEMPLOYED_PEOPLE:
      return action.data;

    case types.UPDATE_REGISTERED_UNEMPLOYED_PEOPLE: {
      const tmpState = [...registeredUnemployedPeopleState];
      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index < 0) return tmpState;

      tmpState[index] = action.data;

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.registeredUnemployedPeople;

    default:
      return registeredUnemployedPeopleState;
  }
};

export default {
  registeredUnemployedPeople,
};
